const Api = global.Api;

export default class {
  constructor() {
    this.userinfo = {};
    this.idperfis = [];
    this.perfis = [];
    this.permissoes = [];
    this.pack = null;
  }

  async loadProfile($store) {
    if (this.pack == null) {
      this.pack = (await Api().get("admin/pessoa/profile", {})).data;
      this.userinfo = this.pack.userinfo;
      this.idperfis = this.pack.perfisids;
      this.perfis = this.pack.perfisnames;
      this.permissoes = this.pack.permissoes;
      //console.log(this.userinfo, this.idperfis, this.perfis, this.permissoes)
      if (this.pack.language) global.language = this.pack.language;
      if (this.userinfo) $store.dispatch("setUser", this.userinfo);
    }
    return this.pack;
  }

  logado_no_perfil(perfil) {
    if (
      this.perfis.indexOf(perfil) != -1 ||
      this.idperfis.indexOf(perfil) != -1
    )
      return true;
    return false;
  }

  perm_can_do(modulo, permissao = null) {
    if (permissao == null) {
      return this.permissoes[modulo] == 1;
    }

    //HACK TO RELEASE PERFIL SEMPRE.
    //if (modulo == "|perfil" && this.idperfis.indexOf(1) !== -1) return true;

    //console.log(this.permissoes[modulo+'--'+permissao], this.permissoes, [modulo+'--'+permissao])
    return this.permissoes[modulo + "--" + permissao] == 1;
  }

  createMenu() {
    const iconmap = global.appmap.icons || {};

    const secoes = {};
    for (let x in global.dbdef) {
      const mod = global.dbdef[x];

      if (!global.features.perm_can_do("|" + mod.modulo.mod_tabela, "menu"))
        continue;

      secoes[mod.modulo.mod_secaomen || "Geral"] =
        secoes[mod.modulo.mod_secaomen || "Geral"] || [];

      const el = {
        text: mod.modulo.mod_titulo,
        url: mod.modulo.mod_tabela,
        "icon-alt": "keyboard_arrow_down"
      };
      if (iconmap[el.text]) {
        el.icon = iconmap[el.text];
      } else {
        el.icon = "settings";
      }

      secoes[mod.modulo.mod_secaomen || "Geral"].push(el);
    }
    for (let s in secoes) {
      secoes[s].sort((a, b) =>
        a.text < b.text ? -1 : a.text > b.text ? 1 : 0
      );
    }
    const menu = [];
    for (let s in secoes) {
      let so = secoes[s];
      if (so.length == 1) {
        menu.push(so[0]);
      } else {
        const el = {
          text: s == "" ? "" : s,
          "icon-alt": "keyboard_arrow_down"
        };
        if (iconmap[el.text]) {
          el.icon = iconmap[el.text];
        } else {
          el.icon = "settings";
        }
        if (s == "") {
          el.model = true;
        }

        el.heading = ["OI GENTE"];

        el.children = so;
        menu.push(el);
      }
    }

    menu.sort((a, b) => (a.text < b.text ? -1 : a.text > b.text ? 1 : 0));
    menu.sort((a, b) => (a.text == "" ? 1 : b.text == "" ? -1 : 0));

    //console.log(menu)
    return menu;
    /*
        return [
            { icon: "contacts", text: "Contacts" },
            { icon: "history", text: "Frequently contacted" },
            { icon: "content_copy", text: "Duplicates" },
            {
              icon: "keyboard_arrow_up",
              "icon-alt": "keyboard_arrow_down",
              text: "Labels",
              model: true,
              children: [{ icon: "add", text: "Create label" }]
            },
            {
              icon: "keyboard_arrow_up",
              "icon-alt": "keyboard_arrow_down",
              text: "More",
              model: false,
              children: [
                { text: "Import" },
                { text: "Export" },
                { text: "Print" },
                { text: "Undo changes" },
                { text: "Other contacts" }
              ]
            },
            { icon: "settings", text: "Settings" },
            { icon: "chat_bubble", text: "Send feedback" },
            { icon: "help", text: "Help" },
            { icon: "phonelink", text: "App downloads" },
            { icon: "keyboard", text: "Go to the old version" }
          ]*/
  }
}
